import script from "./loginv2.vue?vue&type=script&setup=true&lang=js"
export * from "./loginv2.vue?vue&type=script&setup=true&lang=js"

import "./loginv2.vue?vue&type=style&index=0&id=93fbff8c&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93fbff8c"]])

export default __exports__